var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.telemetry2.symbols.beaconIsEnabled)?_c('div',{staticClass:"rotating-light flex-area symbol"},[_c('i',{staticClass:"icon-scania-rotating-beacon_blue"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }